/**
 * Delimiter Tool for EditorJS
 *
 * div 기반 가로줄 블록. prose hr 스타일 간섭을 피하기 위해
 * hr 태그 대신 div + CSS ::before 로 선을 그린다.
 *
 * Based on @editorjs/delimiter (MIT)
 */

const IconDelimiter = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><line x1="6" x2="10" y1="12" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="14" x2="18" y1="12" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>';

export default class Delimiter {
  static get isReadOnlySupported() {
    return true;
  }

  static get contentless() {
    return true;
  }

  static get toolbox() {
    return { icon: IconDelimiter, title: 'Delimiter' };
  }

  static get pasteConfig() {
    return { tags: ['HR'] };
  }

  constructor({ data, config, api }) {
    this.api = api;
    this._element = this._drawView();
  }

  _drawView() {
    const el = document.createElement('div');
    el.classList.add('ce-delimiter', this.api.styles.block);
    return el;
  }

  render() {
    return this._element;
  }

  save() {
    return {};
  }

  onPaste() {
    // HR 붙여넣기 시 delimiter 블록 생성
  }
}
